import React from "react";

export default function useMergeTrackedJobs({
    notificationJobs,
    activeJobPollersRef
}) {
    return React.useMemo(() => {
        if (!notificationJobs) return [];

        return notificationJobs
            .map(j => {
                if (activeJobPollersRef.current[j.jobId]) {
                    return activeJobPollersRef.current[j.jobId].job;
                }
                return j;
            });
    }, [activeJobPollersRef, notificationJobs]);
}